import { Tooltip } from "react-tooltip";

import { ArrowSwapIcon, LogoutIcon } from "components/icons";
import Image from "components/Image";

import { useAuthStore } from "@type/store";
import { useTranslationContext } from "context/TranslationContext";
import cn from "lib/cn";

import styles from "./ActionItem.module.css";

interface ActionItemProps {
  open?: boolean;
  onLogout?: () => void;
  onSwitchApp?: () => void;
}

const ActionItem = ({
  open = false,
  onLogout,
  onSwitchApp,
}: ActionItemProps) => {
  const user = useAuthStore((state) => state.user);
  const { t } = useTranslationContext();

  return (
    <div
      className={cn(
        styles.container,
        "rounded-lg p-2 w-[18rem]",
        open ? styles.animateOpen : styles.animateClose
      )}
    >
      <div className="flex items-center gap-3 p-2">
        <div>
          <Image
            alt={user.fullName}
            imageUrl={user.profilePicture}
            width={40}
            height={40}
            label={user.fullName}
          />
        </div>

        <div className="w-full truncate">
          <div
            className="text-night truncate"
            data-tooltip-id={`${user.idUnique}-name`}
            data-tooltip-content={user.fullName}
          >
            {user.fullName}
          </div>
          <Tooltip id={`${user.idUnique}-name`} place="top-start" />

          <div
            className="text-sm text-gray-500 truncate"
            data-tooltip-id={`${user.idUnique}-email`}
            data-tooltip-content={user.email}
          >
            {user.email}
          </div>
          <Tooltip id={`${user.idUnique}-email`} place="bottom-end" />
        </div>
      </div>

      <div className={styles.separator} />

      <div className="w-full">
        <button
          className="flex items-center gap-2 w-full text-left text-night hover:bg-gray-100 rounded-md p-2"
          onClick={onSwitchApp}
        >
          <ArrowSwapIcon width={20} height={20} />
          <div>{t("switch_app")}</div>
        </button>
      </div>

      <div className={styles.separator} />

      <div className="w-full">
        <button
          className="flex items-center gap-2 w-full text-left text-night hover:bg-gray-100 rounded-md p-2"
          onClick={onLogout}
        >
          <LogoutIcon width={20} height={20} />
          <div>{t("logout")}</div>
        </button>
      </div>
    </div>
  );
};

export default ActionItem;
